<template>
  <div class="yxtbiz-dept-tree-v3" v-loading="loading">
    <div class="yxtbiz-dept-tree-v3-search">
      <yxt-row :type="selectorAlign ? '' : 'flex'">
        <yxtbiz-group-org-select
          v-if="enableGroupCorp && visibleOrgSelector"
          @change="handleOrgChange"
          :selectFirst="true"
          :setCurrentOrg="setCurrentOrg"
          :functionCode="functionCode"
          :dataPermissionCode="dataPermissionCode"
          :clearable="false"
          :targetOrgId="targetOrgId"
          :visibleOrgIds="visibleOrgIds"
          :disabled="disabled"
          size="small"
          class="mr12 mb12"
          :style="selectorAlign ? 'width: 100%' : ''"
        />
        <yxt-input
          class="yxtbiz-dept-tree__input"
          :placeholder="placeholder"
          ref="input"
          size="small"
          style="max-width: 320px;"
          v-model="filterText"
          @search="filter"
          searchable
        >
        </yxt-input>
      </yxt-row>
    </div>
    <div class="yxtbiz-dept-tree-v3-bread-crumb">
      <BreadCrumb
        :bread-crumb-list="breadCrumbList"
        @click="handleBreadCrumb"
      />
    </div>
    <div class="yxtbiz-dept-tree-v3-teee-content">
      <TreeList :tree-list="treeList" @next="handleNext" />
    </div>
  </div>
</template>

<script>
import DeptTreeMixin from './dept-tree-mixins';
import BreadCrumb from './components/bread-crumb.vue';
import TreeList from './components/tree-list.vue';
import { i18n } from '../../common-util/changeLangs';
import { getTree } from './service';
export default {
  name: 'YxtbizDeptTreeV3',
  components: {
    BreadCrumb,
    TreeList
  },
  mixins: [DeptTreeMixin],
  props: {
    selectorAlign: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: function() {
        return i18n.t('biz_udp_deptmentname');
      }
    },
    checkStrictly: {
      type: Boolean,
      default: true
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      breadCrumbList: [{ name: '组织架构', id: '0000' }],
      treeList: []
    };
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      const res = await this.getData();
      this.treeList = res;
    },
    async upateList(id) {
      if (id === '0000') {
        id = '';
      }
      const res = await this.getData(id);
      this.treeList = res;
    },
    async handleNext(data) {
      console.log(data, '----');
      this.breadCrumbList.push(data);
      this.upateList(data.id);
    },
    async handleBreadCrumb(data) {
      console.log(data, '------');
      let newArray = [];
      for (const item of this.breadCrumbList) {
        newArray.push(item);
        if (data.id === item.id) {
          this.breadCrumbList = newArray;
          this.upateList(data.id);
          // 根据当前面包屑对应的map数据，必须在 upateList 之后，需要更新updateList每一项的checked状态
          break;
        }
      }
    },
    handleOrgChange(data) {
      console.log(data, '------');
      this.currentOrgId = data.orgId;
      this.currentOrgName = data.orgName;
      this.filterText = '';
      this.refresh();
      this.$emit('org-change', data);
    },
    AddOrgIdForTree(treeNodes) {
      for (const item of treeNodes) {
        if (item.children && item.children.length) {
          this.AddOrgIdForTree(item.children);
        } else {
          item.orgId = this.currentOrgId;
          item.orgName = this.currentOrgName;
        }
      }
    },
    transformNode(targetNode) {
      // 转换数据，因为新接口返回的数据为缩写过后的字段，暴露出去的时候需要还原
      if (!targetNode) return false;
      const data = {
        ...targetNode,
        id: targetNode.i,
        name: targetNode.n,
        includeAll: targetNode.includeAll,
        userCount: targetNode.c,
        routingPath: targetNode.r,
        hasAllDeptPermission: targetNode.a
      };
      return data;
    },
    async getData(parentId = '') {
      this.loading = true;
      const res = await getTree({
        targetOrgId: this.currentOrgId,
        parentId: parentId,
        navCode: this.functionCode,
        dataPermissionCode: this.dataPermissionCode
      });
      this.loading = false;
      if (this.enableGroupCorp) {
        // tree数据加上orgId
        this.AddOrgIdForTree(res.datas);
      }
      return res.datas.map(item => this.transformNode(item)) || [];
    },
    refresh() {
      this.treeList = [];
      this.filterText = '';
      this.breadCrumbList = this.breadCrumbList.splice(0, 1);
      this.upateList();
    }
  }
};
</script>
<style lang="scss" scoped>
.yxtbiz-dept-tree-v3 {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.yxtbiz-dept-tree-v3-search {
  height: 80px;
}
</style>
